module.exports = __webpack_public_path__ + "static/martin-9e9c7cde313443780563c7457965177c.jpg";